import { dew as _SchemaDew } from "../../Schema";
import { dew as _createIdentitySchemaCreatorDew } from "../../utils/createIdentitySchemaCreator";
import { dew as _getErrorMessageForIncorrectTypeDew } from "../../utils/getErrorMessageForIncorrectType";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.boolean = void 0;
  const Schema_1 = _SchemaDew();
  const createIdentitySchemaCreator_1 = _createIdentitySchemaCreatorDew();
  const getErrorMessageForIncorrectType_1 = _getErrorMessageForIncorrectTypeDew();
  exports.boolean = (0, createIdentitySchemaCreator_1.createIdentitySchemaCreator)(Schema_1.SchemaType.BOOLEAN, (value, {
    breadcrumbsPrefix = []
  } = {}) => {
    if (typeof value === "boolean") {
      return {
        ok: true,
        value
      };
    } else {
      return {
        ok: false,
        errors: [{
          path: breadcrumbsPrefix,
          message: (0, getErrorMessageForIncorrectType_1.getErrorMessageForIncorrectType)(value, "boolean")
        }]
      };
    }
  });
  return exports;
}